export default __webpack_public_path__ + "static/media/dyeing-min.d8873678.png";